import {connect} from 'react-redux';
import React, {Component} from 'react';

class FbShare extends Component {
    static handleFBShareClick(event) {
        event.preventDefault();

        window.FB.ui({
            method: 'share',
            href: window.location.href,
        }, function (response) {
        });
    }

    render() {
        const i18n = this.props.languages.i18n;
        return (
            <a href="" onClick={FbShare.handleFBShareClick} className="fb-share">
                <span></span>
                {i18n['objectPage.share']}
            </a>
        )
    }
}

const mapStateToProps = state => {
    const languages = state.languages;

    return {
        languages
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FbShare);


// WEBPACK FOOTER //
// ./src/components/PropertyPage/FbShare.js